export default __webpack_public_path__ + "static/media/26.99175f4b.mp3";